import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/kontaktai/page.tsx");
